<template>
  <v-flex xs12>
    <v-card>
      <v-layout row wrap justify-space-between align-center class="px-3 pt-2">
        <v-flex xs12 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-flex xs12 px-4 v-if="successM">
          <v-alert :value="true" type="success">{{successM}}</v-alert>
        </v-flex>
        <div class="d-inline-flex pt-2">
          <p class="p-0 m-0">{{$lang.labels.name}}:
            <span :style="goDark ? 'color: white' : ''">
            <strong>{{ formatName(order.contact) }}</strong>
          </span>
          </p>
          <p v-if="order.contact.address" class="pl-5 py-0 m-0">{{$lang.labels.address}}:
            <span :style="goDark ? 'color: white' : ''">
            <strong>{{ generateAddress([
              order.contact.address.line1,
              order.contact.address.line2,
              order.contact.address.line3,
              order.contact.address.line4,
            ]) }}, {{ order.contact.address.locality ? order.contact.address.locality + ', ' : '' }} {{ order.contact.address.country === 'UK' ? order.contact.address.townCity : order.contact.address.postalCode }}, {{ order.contact.address.country === 'UK' ? order.contact.address.postalCode : order.contact.address.townCity }}</strong>
          </span>
          </p>
        </div>
        <div class="d-inline-flex">
          <v-icon @click="$emit('close')">clear</v-icon>
        </div>
      </v-layout>
      <v-layout row wrap justify-space-between class="px-2">
        <p class="px-2">{{$lang.labels.deliveryType}}:
          <span :style="goDark ? 'color: white' : ''">
            <strong>{{ $lang.actions[order.type] }}</strong>
          </span>
        </p>
        <p class="px-2">{{ orderTimeLabel() }} {{ $lang.labels.time }}:
          <span :style="goDark ? 'color: white' : ''">
            {{ formatDate(order.deliveryTime) }}
          </span>
        </p>
        <p class="px-2">{{ $lang.header.rating }}:&nbsp
          <template v-for="star in 5">
            <v-icon :key="star"
                    size="19"
                    :color="order.ratingStars >= star ? 'primary' : ''">star
            </v-icon>
          </template>
          <br v-if="order.ratingComment">
          <small v-if="order.ratingComment">{{$lang.labels.comment}}: </small>
          <span v-if="order.ratingComment"><small>{{order.ratingComment}}</small></span>
        </p>
        <p class="px-2">{{$lang.labels.total}}:
          <span :style="goDark ? 'color: white' : ''">
            <strike
              v-if="order.totalAmountWithoutDiscount !== null &&
                parseFloat(order.totalAmountWithoutDiscount) !== parseFloat(order.totalAmount)">
              ₤{{ parseFloat(order.totalAmountWithoutDiscount).toFixed(2) }}
            </strike>
            ₤{{ parseFloat(order.totalAmount).toFixed(2) }}
          </span>
        </p>
      </v-layout>
      <v-layout row wrap justify-space-between class="px-3">
      <div class="v-table__overflow mb-4" v-if="items && items.length > 0">
        <table class="v-datatable v-table">
          <thead>
          <tr :style="goDark ? 'background-color: #303030' : ''">
            <th role="columnheader" scope="col" class="column text-xs-left">{{$lang.labels.quantity}}</th>
            <th role="columnheader" scope="col" class="column text-xs-left">{{$lang.labels.name}}</th>
            <th role="columnheader" scope="col" class="column text-xs-right">{{$lang.labels.details}}</th>
            <th role="columnheader" scope="col" class="column text-xs-right">{{$lang.labels.total}}</th>
          </tr>
          <tr class="v-datatable__progress"><th colspan="100%" class="column"></th></tr>
          </thead>
          <tbody>
          <template v-for="(item, index) in items">
            <tr :key="index" :class="{'is-selected': item.selected}" class="item" :style="goDark && (index %2 || item.selected) ? 'background-color: #303030' : ''">
              <td class="text-xs-left" style="min-width: 130px;">
                <span class="quantity">{{ item.quantity }}</span>
              </td>
              <td class="text-xs-left">{{item.name[$lang.current_lang] ? item.name[$lang.current_lang] : item.name.en }}</td>
              <td class="text-xs-right"><v-icon color="primary" @click="selectCartItem(index)">info</v-icon></td>
              <td class="text-xs-right"><p class="price">{{company ? company.currencySymbol : '₤'}}{{$store.state.calculatePrice(item.selectedSize, item.selectedVariants, item.selectedOptions, item.quantity, item.quantityOfIncludedOptions).toFixed(2)}}</p></td>
            </tr>
            <tr v-if="item.selected" :key="index + 10000">
              <td colspan="4">
                <ul class="layout row wrap">
                  <li class="flex py-2 xs4" v-if="item.selectedSize.name" xs6>{{$lang.labels.size}}: {{ item.selectedSize.name[$lang.current_lang] ? item.selectedSize.name[$lang.current_lang] : item.selectedSize.name.en }}</li>
                  <li class="flex py-2 xs4" v-if="item.selectedStyle.name" xs6>{{$lang.labels.style}}: {{ item.selectedStyle.name[$lang.current_lang] ? item.selectedStyle.name[$lang.current_lang] : item.selectedStyle.name.en }}</li>
                  <li class="flex py-2 xs4" v-if="item.selectedVariants && item.selectedVariants.name" xs6>{{$lang.labels.variant}}: {{ item.selectedVariants.name[$lang.current_lang] ? item.selectedVariants.name[$lang.current_lang] : item.selectedVariants.name.en }}</li>
                  <li class="flex py-2 xs4" v-if="item.selectedOptions && item.selectedOptions.length > 0" xs6>
                    {{$lang.labels.options}}:
                    <ul class="pl-4">
                      <li v-for="(option, index) in item.selectedOptions" :key="index">{{ option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en }} x {{option.quantity}}</li>
                    </ul>
                  </li>
                  <li class="flex py-2 xs12" v-if="item.comment" md12>{{$lang.labels.comment}}: {{item.comment}}</li>
                </ul>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      </v-layout>
      <v-layout row wrap justify-space-between class="px-2">
        <p class="px-2">{{$lang.labels.createdOn}}:
          <span :style="goDark ? 'color: white' : ''">
            {{ formatDate(order.createdOn) }}
          </span>
        </p>
      </v-layout>
      <v-layout row wrap justify-space-between class="px-2 pb-2">
        <div class="d-inline-flex">
          <p class="pl-2 pt-2">Blacklist:</p>
          <v-btn color="error" @click="blacklist('email')">{{$lang.labels.email}}</v-btn>
          <v-btn color="error" @click="blacklist('phone')">{{$lang.labels.phone}}</v-btn>
          <v-progress-circular indeterminate class="mt-2" v-if="loading"></v-progress-circular>
        </div>
        <v-btn @click="$emit('close')">{{$lang.actions.close}}</v-btn>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  props: ['order'],
  data: () => ({
    err: '',
    successM: '',
    loading: false,
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Quantity', value: 'quantity', align: 'right' },
    ],
    items: [],
  }),
  computed: {
    ...mapGetters({
      company: 'company',
      goDark: 'goDark',
    }),
  },
  methods: {
    blacklist(type) {
      this.loading = true;
      this.$webHelper.post(`blacklist/${this.order.webShopOrderId}?type=${type}`)
        .then((res) => {
          if (res.status === 200) {
            this.successM = this.$lang.success.blacklist;
            this.loading = false;
            setTimeout(() => {
              this.successM = '';
            }, 6000);
            return;
          }
          this.err = res.body.statusText;
          this.loading = false;
          setTimeout(() => {
            this.err = '';
          }, 6000);
        })
        .catch((err) => {
          this.err = err.body.statusText;
          this.loading = false;
          setTimeout(() => {
            this.err = '';
          }, 6000);
        });
    },
    generateAddress(lines) {
      return lines.filter(line => !!line)
        .join(', ');
    },
    formatName(contact) {
      return `${contact.firstName || ''} ${contact.lastName || ''}`;
    },
    orderTimeLabel() {
      return this.$lang.actions[this.order.type];
    },
    selectCartItem(index) {
      this.items = this.items.map((current, i) => {
        const item = current;
        item.selected = i === index && !item.selected;
        return item;
      });
    },
    formatDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm');
    },
  },
  created() {
    this.items = this.order.items.map(item => Object.assign({}, item, { selected: false }));
  },
};
</script>

<style lang="scss" scoped>
  p {
    font-size: 16px;
    color: #efa546;
    span {
      color: rgba(#000, 0.75);
    }
  }
  .sub-header {
    flex: 0.2 1 auto;
  }
  thead {
    background-color: #dcdcdc;
  }
  table.table thead tr {
    height: 44px;
  }
  tr{
    &.item:nth-of-type(even) {
      background-color: #f3f3f3;
    }
    &.item.is-selected,
    &.item.is-selected:hover{
      td {
        background: rgba($color: #dcdcdc, $alpha: 0.6);
        font-weight: 700;
      }
    }
  }
  .price {
    min-width: 56px;
    display: inline-block;
    margin: 0;
    padding-left: 8px;
    position: relative;
    text-align: right;
    &:before {
      content: attr(data-currency);
      position: absolute;
      left: 0;
    }
    &.no-min {
      min-width: 1px;
    }
  }
  .quantity {
    display: inline-block;
    width: 24px;
    height: 24px;
    text-align: center;
  }
  .total {
    font-size: 13px;
  }
  @media only screen and (max-width: 768px) {
    .sub-header {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/modals/OrderDetails.vue